import { Injectable } from "@angular/core";
import { Http, Headers } from '@angular/http';
import { HeaderService } from '../http/header.service';
import { SessionService } from "../session/session.service";
import { ProcessoService } from './../processo/processo.service';
import { Observable } from 'rxjs/Observable';
import { Matricula, RegrasCalouro } from "./matricula"; // Importa a classe Matricula
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';

@Injectable()
export class MatriculaService {

  constructor(
    private http: Http,
    private HeaderService: HeaderService,
    private SessionService: SessionService,
    private ProcessoService: ProcessoService,
  ) {}

  // Ch: 427368 - Jonathan Santos - 19/02/2025
  public verificaMatriculaCalouro(): Observable<Matricula> {
    const headers = this.HeaderService.getHeadersGnx();

    const processo = this.ProcessoService.getProcessoSeletivoSelecionado();
    const pessoa = JSON.parse(this.SessionService.getValor("pessoa"));

    const body = {
      PesCod: Number(pessoa.pes_cod_comp),
      LetAno: processo.PrcLetAno -2000,
      LetSem: processo.PrcLetSem,
      IngCod: 0,
      ConfigIngCod: processo.PrcIngCod
    };

    return this.http
      .post(environment.apiGxUrl + '/WsVerificaMatriculaCalouro.svc/rest/', body, { headers: headers })
      .map((resposta: any) => {
        const retorno = JSON.parse(resposta._body);
        return new Matricula(retorno.possuiMatriculaCalouro == true);
      });
  }

  public verificaRegrasCalouro(): Observable<RegrasCalouro> {
    const headers = this.HeaderService.getHeadersGnx();
    const processo = this.ProcessoService.getProcessoSeletivoSelecionado();
    const pessoa = JSON.parse(this.SessionService.getValor("pessoa"));
    const cursoSelecionado = JSON.parse(this.SessionService.getValor("cursoSelecionado"));

    const body = {
      PrcLetAno: processo.PrcLetAno,
      PrcLetSem: processo.PrcLetSem,
	    PrcTipCod: processo.PrcTipCod,
	    PrcOcoSeq: cursoSelecionado.PrcOcoSeq,
	    PrcOfeSeq: cursoSelecionado.PrcOfeSeq,
	    VPesCodCom: Number(pessoa.pes_cod_comp)
    };

    return this.http
      .post(environment.apiGxUrl + '/WsPrcValidaIngCalProcesso.svc/rest/', body, { headers: headers })
      .map((resposta: any) => {
        const retorno = JSON.parse(resposta._body);
        return new RegrasCalouro(retorno.Mensagem, retorno.isProsseguir == true);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/matricula/matricula.service.ts